/**
 * Markdown as plain text, for one-line previews and banners of what Claude last said: no
 * literal asterisks, backticks, heading hashes or link syntax. Line breaks stay; list items
 * keep a bullet. The full message renders as markdown in the transcript.
 */
export function plainText(md: string): string {
  if (!md) return '';
  return (
    md
      // Fenced code: keep the code, drop the fences.
      .replace(/```[^\n]*\n?/g, '')
      .replace(/^\s{0,3}#{1,6}\s+/gm, '')
      .replace(/^\s{0,3}>\s?/gm, '')
      .replace(/^(\s*)[-*+]\s+(?=\S)/gm, '$1• ')
      .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
      .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
      .replace(/(\*\*|__)(?=\S)([\s\S]*?\S)\1/g, '$2')
      .replace(/(^|[^\w*])\*(?=\S)([^*\n]*?\S)\*(?!\w)/g, '$1$2')
      .replace(/(^|[^\w_])_(?=\S)([^_\n]*?\S)_(?!\w)/g, '$1$2')
      .replace(/~~(?=\S)([^~\n]*?\S)~~/g, '$1')
      .replace(/`([^`\n]+)`/g, '$1')
      // QA-49: a message clipped mid-markup leaves an opener with no closer ("**`inde..."): drop it.
      .replace(/\*\*|__|`/g, '')
  );
}

/**
 * Markdown as one plain line, for row summaries: plainText, then line breaks and list bullets
 * (at a line start, or inline after a colon or full stop when the source was already flattened)
 * fold into single spaces.
 */
export function summaryLine(md: string): string {
  return plainText(md)
    .replace(/^\s*•\s+/gm, '')
    .replace(/([:.;!?])\s+[-*+•]\s+(?=\S)/g, '$1 ')
    .replace(/\s+/g, ' ')
    .trim();
}
